import { fluidType } from 'Shared/common/FluidType';

export function amount(a)
{
	if (a?.type == 'fluid')
		return fluidType('px',a.pageMin,a.pageMax,a.minValue,a.maxValue);
	if (a == 'full')
		return '100%';

	return a;
}

